export default __webpack_public_path__ + "static/media/background-music.908006a8.jpg";